document.addEventListener('turbolinks:load', function () {
  const ERROR_MSG = 'エラー！　処理を完了できませんでした\n時間おいて再度実行しても、このエラーが修正されない場合は\nお手数ですがサポートチームにお問い合わせください';
  const MAIL_PATTERN = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  const PASSWORD_PATTERN = /([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/;
  //*********************************************************************
  // 初期処理系
  //*********************************************************************
  //############################################################
  // フォーカス
  //############################################################
  if (location.pathname == '/new' || location.pathname == '/login' || location.pathname == '/') {
    $("input[type='text']:visible").eq(0).focus();
  }

  //############################################################
  // エンター押下
  //############################################################
  $(document).keypress(function (e) {
    if (e.keyCode == 13 && e.target.nodeName !== 'TEXTAREA') {
      $('.enter').click();
      return false;
    }
  });

  //############################################################
  // スペーストリム
  //############################################################
  $('input,textarea').on('blur', function () {
    $('input,textarea').each(function (i, e) {
      $(e).val($.trim($(e).val()));
    });
    $("input[type='text']").trigger('keyup');
    $("input[type='email']").trigger('keyup');
    $('textarea').trigger('keyup');
  });

  //############################################################
  // ログイン
  //############################################################
  $('#crm_login').on('click', function () {
    if ($('#id').val() == '' || $('#password').val() == '') {
      return;
    }

    $.ajax({
      url: './login_req',
      type: 'POST',
      data: {
        id: $('#id').val(),
        password: $('#password').val(),
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 1) {
        location.href = './index';
      } else {
        alert('NG');
      }
    });
  });

  //############################################################
  // CUSTOMER
  //############################################################
  $('#customer_index tr').on('click', function () {
    location.href = './edit?id=' + $(this).data('val');
  });

  //############################################################
  // CUSTOMER登録
  //############################################################
  $('#update_customer').on('click', function () {
    // バリデーション
    if ($('#name').val() == '') {
      alert('社名を入力してください');
      return;
    }

    let req_name;
    if ($(this).data('val')) {
      req_name = 'update_customer';
    } else {
      req_name = 'create_customer';
    }
    $.ajax({
      url: './' + req_name,
      type: 'POST',
      data: {
        id: $(this).data('val'),
        name: $('#name').val(),
        person: $('#person').val(),
        mail: $('#mail').val(),
        tel: $('#tel').val(),
        preferred_date: $('#preferred_date').val(),
        domain: $('#domain').val(),
        account_name: $('#account_name').val(),
        password: $('#password').val(),
        tag: $('#tag').val(),
        cv_tag: $('#cv_tag').val(),
        text: $('#text').val(),
        stat: $('#stat').val(),
        tag_stat: $('#tag_stat').val(),
        tag_check: $('#tag_check').val(),
        tag_fire: $('#tag_fire').val(),
        access_token: $('#access_token').val(),
        customer_posts: $('#customer_posts').val(),
        customer_preview: $('#customer_preview').val(),
        customer_release: $('#customer_release').val(),
        cv_tag_check: $('#cv_tag_check').val(),
        log_check: $('#log_check').val(),
        top_page: $('#top_page').val(),
        detail_page: $('#detail_page').val(),
        cart_page: $('#cart_page').val(),
        thanks_page: $('#thanks_page').val(),
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.href = './index';
      }
    });
  });

  //############################################################
  // progress
  //############################################################
  // $('.row').on('click', function () {
  //   location.href = './progress_edit?id=' + $(this).data('customer') + '&p=' + $(this).data('progress');
  // });

  //############################################################
  // 商談（progress）登録
  //############################################################
  $('#update_progress').on('click', function () {
    // バリデーション
    if ($('#create_date').val() == '') {
      alert('日時を入力してください');
      return;
    }
    if ($('#text').val() == '') {
      alert('商談内容を入力してください');
      return;
    }

    let req_name;
    if ($(this).data('progress')) {
      req_name = 'update_progress';
    } else {
      req_name = 'create_progress';
    }
    $.ajax({
      url: './' + req_name,
      type: 'POST',
      data: {
        cid: $(this).data('customer'),
        pid: $(this).data('progress'),
        create_date: $('#create_date').val(),
        text: $('#text').val(),
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.href = './edit?id=' + data.cid;
      }
    });
  });
});
